import React from 'react';
import { Cell } from 'react-table';

import { Tooltip } from '../..';
import { TooltipColumn } from '../types';
import { defaultCellWidth, defaultTooltipPosition } from '../constants';

interface Props {
    cell: Cell<PerformanceTableItem>;
    column: TooltipColumn<PerformanceTableItem>;
}

/**
 * Returns a value based on data from a PerformanceTableItem:
 *   - Show is displayed if present
 *   - Episode is also displayed if present
 *   - if both are 'not_available' or not present, an emdash is displayed
 *   - if one is present, it is shown, and an emdash is displayed for the other
 */
export function ProgramCell({ cell, column }: Props): JSX.Element | string {
    const {
        value: { Episode, Show },
    } = cell;
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const width = (column?.width as number) ?? defaultCellWidth;
    const finalWidth = width - 10;
    const showAndEpisodeAreEmpty = Show.length === 0 && Episode.length === 0;
    const showAndEpisodeAreNotReported =
        Show === 'not_reported' && Episode === 'not_reported';

    if (showAndEpisodeAreEmpty || showAndEpisodeAreNotReported) {
        return <div>—</div>;
    }

    const displayShow = Show === 'not_reported' ? '—' : Show;
    const displayEpisode = Episode === 'not_reported' ? '—' : Episode;

    return (
        <div>
            {Show.length > 0 && (
                <Tooltip message={displayShow} position={position}>
                    <div
                        className="respond-to-mouse truncate font-semibold"
                        style={{
                            width: finalWidth,
                        }}
                    >
                        {displayShow}
                    </div>
                </Tooltip>
            )}
            {Episode.length > 0 && (
                <Tooltip message={displayEpisode} position={position}>
                    <div
                        className="respond-to-mouse truncate"
                        style={{
                            width: finalWidth,
                        }}
                    >
                        {displayEpisode}
                    </div>
                </Tooltip>
            )}
        </div>
    );
}
